<template>
  <div class="image-grid-container">
    <div class="image-grid">
      <div class="image-item" v-for="(image, index) in allImages" :key="index">
        <!-- 测试 -->
        <!-- <img src="https://picsum.photos/id/1015/600/800" :alt="image" /> -->
        <!-- 正式 -->
        <img :src="imgUrl?.url.replace(/\/$/, '')+image" :alt="image" />
        <!-- <img :src="'http://127.0.0.1'+image" :alt="image" /> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityStyle",
  props: {
    imgUrl: {
      type: Object,
      default: {}, // 默认空数组
    },
    allImages: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // allImages: [
      //   'https://via.placeholder.com/150/0000FF/808080?Text=Image1',
      //   'https://via.placeholder.com/150/FF0000/FFFFFF?Text=Image2',
      //   'https://via.placeholder.com/150/00FF00/FFFFFF?Text=Image3',
      //   'https://via.placeholder.com/150/0000FF/808080?Text=Image4',
      //   'https://via.placeholder.com/150/FF0000/FFFFFF?Text=Image5',
      //   'https://via.placeholder.com/150/00FF00/FFFFFF?Text=Image6',
      // ]
    };
  }
};
</script>

<style scoped>
.image-grid-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-grid {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 0.5%; /* 图片之间的间隙 */
}

.image-item {
  width: 33%; /* 100% / 3 - 间隙 */
  height: 17vw;
  /* aspect-ratio: 1; /* 保持正方形 */
  text-align: center;
  /* border: 1px solid red; */
  margin-bottom: 0.5vw;
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .image-item {
    width: 100%; /* 移动端每行显示2个 */
    height: 50vw;
    margin-bottom: 8px;

  }
}


</style>
